class ListModulInicializator extends ModulInicializator {
    protected configuration: IListModulInicializatorConfiguration;

    constructor(configuration: IListModulInicializatorConfiguration) {
        super(configuration);
    }

    protected getDefaultConfiguration() {
        return this.parseConfig({
            searchBox: {
                inputFieldElement: ".searchbar-input",
                searchBoxInputSelector: ".searchbar-input.tt-input",
                dataSet: {
                    name: "Title",
                    groupHeader: localization.translate("TitleSearchBox", "PluginsJs").value,
                    parameterUrlString: null
                }
            },
            search: {
                placeholder: localization.translate("SearchInTitles...", "PluginsJs").value
            }
        }, super.getDefaultConfiguration());
    }

    public init() {
        this.getBibliographyModule();

        if (this.configuration.onlyBibliographyModule)
            return;

        this.getSearch();
        this.getSearchBox();
        this.getDropDownSelect();

        this.initializeFromUrlParams();
    }

    protected createDropDownSelect() {
        const callbackDelegate = new DropDownSelectCallbackDelegate();

        const treeSelectConfig = this.configuration.dropDownSelect;

        const legacyBooksSelect = treeSelectConfig.legacyBooksSelect ?? true;
        const newBooksSelect = treeSelectConfig.newBooksSelect;

        callbackDelegate.selectedChangedCallback = (state: State) => {
            var serializedState = this.dropDownSelect.getSerializedState();
            updateQueryStringParameter(this.configuration.base.url.selectionKey, serializedState);

            var parametersUrl = DropDownSelect2.getUrlStringFromState(state);
            var searchBox = this.getSearchBox();
            searchBox.clearAndDestroy();
            searchBox.addDataSet(
                this.configuration.searchBox.dataSet.name,
                this.configuration.searchBox.dataSet.groupHeader,
                parametersUrl
            );
            searchBox.create();
            searchBox.value($(this.configuration.searchBox.searchBoxInputSelector).val());
        };

        const dropDownSelect = new DropDownSelect2(
            this.configuration.dropDownSelect.dropDownSelectContainer,
            this.configuration.dropDownSelect.dataUrl,
            this.configuration.search.favoriteQueries.bookType,
            // showStar = enableFavorites
            this.configuration.dropDownSelect.showStar,
            callbackDelegate,
            {
                extraCssClasses: ['books-select'],
                enableFilter: this.configuration.dropDownSelect.enableFilter,
                enableLegacyImplementation: legacyBooksSelect,
                openDropdownAtStart: false,
            },
        );

        if (newBooksSelect) {
            dropDownSelect.listenToNewBooksSelect();
            dropDownSelect.addNewBooksSelect();
        }

        callbackDelegate.dataLoadedCallback = () => {
            $("#listResults").removeClass("loader");
            this.initializeFromUrlParams();
        };

        dropDownSelect.makeDropdown();

        return dropDownSelect;
    }

    //---------------------------------------------------

    protected getSearchBox() {
        if (this.searchBox === undefined) {
            this.searchBox = this.createSearchBox();
        }

        return this.searchBox;
    }

    protected createSearchBox() {
        var searchBox = new BooksSearchBox(
            this.configuration.searchBox.inputFieldElement,
            this.configuration.searchBox.controllerPath
        );
        searchBox.addDataSet(
            this.configuration.searchBox.dataSet.name,
            this.configuration.searchBox.dataSet.groupHeader
        );
        searchBox.create();
        //var searchBoxOnput = $(this.configuration.searchBox.searchBoxInputSelector);
        //searchBox.value(searchBoxOnput.val());

        //searchBoxOnput.change(() => { //prevent clearing input value on blur()
        //    searchBox.value(searchBoxOnput.val());
        //});

        this.search.setOverrideQueryCallback(newQuery => searchBox.value(newQuery));

        return searchBox;
    }
}

interface IListModulInicializatorConfiguration extends IModulInicializatorConfiguration {
    searchBox: {
        inputFieldElement?: string;
        controllerPath: string;

        dataSet?: {
            name?: string;
            groupHeader?: string;
            parameterUrlString?: string;
        };
        searchBoxInputSelector?: string;
    };

    onlyBibliographyModule?: boolean;
}
